/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type TakeOverButtonStartHandlingVehicleMutationVariables = Types.Exact<{
  vehicleId: Types.Scalars['ID']['input']
}>

export type TakeOverButtonStartHandlingVehicleMutation = {
  __typename?: 'Mutation'
  fccStartHandlingVehicle: any | null
}

export const TakeOverButtonStartHandlingVehicleDocument = gql`
    mutation TakeOverButtonStartHandlingVehicle($vehicleId: ID!) {
  fccStartHandlingVehicle(vehicleId: $vehicleId)
}
    `
export type TakeOverButtonStartHandlingVehicleMutationFn =
  Apollo.MutationFunction<
    TakeOverButtonStartHandlingVehicleMutation,
    TakeOverButtonStartHandlingVehicleMutationVariables
  >

/**
 * __useTakeOverButtonStartHandlingVehicleMutation__
 *
 * To run a mutation, you first call `useTakeOverButtonStartHandlingVehicleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTakeOverButtonStartHandlingVehicleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [takeOverButtonStartHandlingVehicleMutation, { data, loading, error }] = useTakeOverButtonStartHandlingVehicleMutation({
 *   variables: {
 *      vehicleId: // value for 'vehicleId'
 *   },
 * });
 */
export function useTakeOverButtonStartHandlingVehicleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TakeOverButtonStartHandlingVehicleMutation,
    TakeOverButtonStartHandlingVehicleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    TakeOverButtonStartHandlingVehicleMutation,
    TakeOverButtonStartHandlingVehicleMutationVariables
  >(TakeOverButtonStartHandlingVehicleDocument, options)
}
export type TakeOverButtonStartHandlingVehicleMutationHookResult = ReturnType<
  typeof useTakeOverButtonStartHandlingVehicleMutation
>
export type TakeOverButtonStartHandlingVehicleMutationResult =
  Apollo.MutationResult<TakeOverButtonStartHandlingVehicleMutation>
export type TakeOverButtonStartHandlingVehicleMutationOptions =
  Apollo.BaseMutationOptions<
    TakeOverButtonStartHandlingVehicleMutation,
    TakeOverButtonStartHandlingVehicleMutationVariables
  >
